// Transform block tree state scenario to block server api

const BlockScenarioTransformer = (origin) => {

    const data = { ...origin };
    
    return data
}

export default BlockScenarioTransformer;